import { getSessionStorageValue, setSessionStorageValue } from '~/hooks/use-session-storage';

const SESSION_STORAGE_KEY = 'SUBSCRIPTION-SEEN-IN-ONBOARDING';

/**
 * Records that the customer was shown a subscription page (the Subscribe step, or a hand-off to My
 * Plan) during SmartSend onboarding. Read by the account routes to decide whether the My Plan tab is
 * shown. Session-scoped, so it lasts for this visit only. The storage helpers swallow failures, so
 * blocked storage never stops onboarding - the tab simply stays hidden.
 */
export function markSubscriptionSeenInOnboarding(): void {
  setSessionStorageValue(SESSION_STORAGE_KEY, true);
}

/** Whether `markSubscriptionSeenInOnboarding` has run in this browser session. */
export function hasSeenSubscriptionInOnboarding(): boolean {
  return getSessionStorageValue<boolean>(SESSION_STORAGE_KEY) === true;
}
